"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
function default_1() {
    return {
        required: i18next_1.default.t('비밀번호를 입력해주세요'),
        requiredPattern: i18next_1.default.t('영문/숫자/특수문자 조합으로 8~20자 입력해주세요'),
        noEmptySpace: i18next_1.default.t('사용 불가: 공백 문자를 지워주세요'),
        notAllowedChars: i18next_1.default.t('특수문자는 !@#$%^&*_-.? 만 사용할 수 있어요'),
        exceededLength: i18next_1.default.t('최대 20자까지 입력해주세요'),
        diffConfirm: i18next_1.default.t('비밀번호가 일치하지 않아요. 똑같이 입력해주세요!'),
        samePwdInputs: i18next_1.default.t('현재 비밀번호와 똑같아요. 다른 비밀번호를 입력해주세요!'),
    };
}
exports.default = default_1;
